import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import MyLibraryTable from "Pages/MyLibrary/MyLibraryTable";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import { useContext, useEffect, useState } from "react";
import { Card } from "reactstrap";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
import {
  BASE_URL,
  GET_SYLLABUSMATER,
} from "utilFunctions/Constants/urlConstants";
import { plannerColumnSortMap } from "utilFunctions/Constants/Constants";
import {
  FilterObject,
  filterArrayBasedOnObjectKeys,
  removeEmptyFields,
} from "utilFunctions/helperFunctions/HelperFunction";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import MyLibraryHeader from "Pages/MyLibrary/MyLibraryHeader";
const SORT_ASC = "ASC";

const MyLibraryHomePage = () => {
  const fetchUrl = BASE_URL + GET_SYLLABUSMATER;
  const { masters } = useMasterContext();
  const userInfo = useContext<any>(UserInfoContext);
  const [data, setData] = useState<any[]>([]);
  const [previousData, setPreviousData] = useState<any[]>([]);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterState, setFilterState] = useState<any>({});
  const [open, setOpen] = useState<boolean>(false);
  const [sortOrder, setSortOrder] = useState(SORT_ASC);
  const [sortColumn, setSortColumn] = useState<any>(
    plannerColumnSortMap["uat"]
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [limit] = useState<number>(500);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { screen }: any = useWindowSize();
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 10,
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    current: 1,
    sortField: "updatedAt",
    sortOrder: "DESC",
  });
  console.log(pagination);
  const [chipShow, setChipShow] = useState<any>({});
  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    let newUrl =
      fetchUrl +
      "?sortBy=" +
      sortColumn +
      "&sortDir=" +
      sortOrder +
      "&offset=" +
      0 +
      "&limit=" +
      limit;
    const filters = [];
    const formValues: any = filterState;
    for (const key in formValues) {
      if (Object.prototype.hasOwnProperty.call(formValues, key)) {
        if (formValues[key] != null && formValues[key] != "") {
          filters.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(formValues[key])
          );
        }
      }
    }
    if (Array.isArray(filters) && filters.length > 0) {
      newUrl = newUrl + "&" + filters.join("&");
    }
    fetchData(newUrl);
  }, []);
  useEffect(() => {
    const filters: FilterObject = removeEmptyFields(filterState);
    const filteredArray = filterArrayBasedOnObjectKeys(previousData, filters);
    setData(filteredArray);
    setCurrentPage(1);
    setItemsPerPage(10);
  }, []);
  const fetchData = async (url: string) => {
    setLoading(true);
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        const data = response?.data;
        console.log("datadatadata response", data);
        if (data["data"].length > 0) {
          setPreviousData(data.data ? data.data : []);
          setPagination({
            ...pagination,
            total: data["data"].length,
          });
          setData(data.data ? data.data : []);
          console.log("reponsedata", data?.data);
        } else {
          console.log("reponsedata", data?.data);

          setData([]);
          setPreviousData([]);
        }
        setTimeout(() => {
          setLoading(false);
        }, 300);
      },
      failure: (err: any) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: err?.message,
        });
        setData([]);
        setPreviousData([]);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      },
    } as getRequestInterface);
  };
  const applyFilterHandler = (filterState: any) => {
    const filters: FilterObject = removeEmptyFields(filterState);
    delete filters["chipFieldName"];
    const filteredArray = filterArrayBasedOnObjectKeys(previousData, filters);
    setData(filteredArray);
    setPagination({
      ...pagination,
      total: filteredArray.length,
    });
    setOpen(false);
  };
  return (
    <div
      className={
        ["xs", "sm", "md"].includes(screen)
          ? "batchTableContainerMB"
          : "batchTableContainer"
      }
    >
      <MyLibraryHeader
        filterState={filterState}
        setFilterState={setFilterState}
        handleAppliedFilter={applyFilterHandler}
        open={open}
        setOpen={setOpen}
        userInfo={userInfo}
        chipShow={chipShow}
        setChipShow={setChipShow}
        stream={masters?.streams}
        acadYears={masters?.acadYears}
        classes={masters?.classes}
        subjects={userInfo?.subjectsListing}
        boards={masters?.boards}
        setPagination={setPagination}
      ></MyLibraryHeader>
      <Card className="libraryCardContainer mt-3">
        <MyLibraryTable
          masters={masters}
          userInfo={userInfo}
          loading={loading}
          data={currentData}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          pagination={pagination}
          setPagination={setPagination}
          onPageChange={handlePageChange}
          setItemsPerPage={setItemsPerPage}
        ></MyLibraryTable>
      </Card>
    </div>
  );
};
export default MyLibraryHomePage;
